import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=23f0b72a&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=23f0b72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0b72a",
  null
  
)

export default component.exports